export function getStorableBarcode(storable: {barcode?: {value: string} | string | null}): string | null {
  if (storable.barcode && typeof storable.barcode === 'object') {
    return storable.barcode?.value ?? null;
  } else {
    return storable.barcode ?? null;
  }
}
